import "./illus2.css";

const Illus2 = () => {
  return (
    <svg
      className="animated"
      id="freepik_stories-psychologist"
      version="1.1"
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        className="animable"
        id="freepik--Shadow--inject-10"
        style={{ transformOrigin: "250px 416.24px" }}
      >
        <ellipse
          className="animable"
          id="freepik--path--inject-10"
          style={{
            fill: "rgb(245, 245, 245)",
            transformOrigin: "250px 416.24px",
          }}
          cx="250"
          cy="416.24"
          rx="193.89"
          ry="11.32"
        />
      </g>
      <g
        className="animable"
        id="freepik--character-1--inject-10"
        style={{ transformOrigin: "219.259px 335.56px" }}
      >
        <g id="eling6ieloic">
          <rect
            className="animable"
            height="6.54"
            style={{
              fill: "rgb(11, 229, 179)",
              transformOrigin: "80.31px 335.43px",
              transform: "rotate(-18.68deg)",
            }}
            width="1"
            x="79.81"
            y="332.16"
          />
        </g>
        <g id="el22vy8esncex">
          <path
            className="animable"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: "148.286px 338.54px",
            }}
            d="M185.26,331.37c-4.67-13.83-19.67-25-33.5-25H116c-13.83,0-21.24,11.21-16.57,25l13.3,39.34,85.81-.06Z"
          />
        </g>
        <g id="eltkm9cjlua6">
          <rect
            className="animable"
            height="21.15"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: "309.73px 381.225px",
              transform: "rotate(180deg)",
            }}
            width="103.16"
            rx="7.34"
            x="258.15"
            y="370.65"
          />
        </g>
        <g id="elwzm9993krpi">
          <path
            className="animable"
            style={{ opacity: "0.3", transformOrigin: "243.28px 336.965px" }}
            d="M210.24,326.71a296,296,0,0,1,59.59-14.79c18.26-2.5,21.58,48,21.58,48l-13.29,2.18c-2.45-14.06-10.1-17.87-13.49-28.49-14.26,13.28-45.83,24.75-69.48,15.12,3.62-9.43,4.95-10.92,8.6-16.56C206.84,327.44,210.24,326.71,210.24,326.71Z"
          />
        </g>
        <g id="elqq46qsjk2y">
          <path
            className="animable"
            style={{ opacity: "0.2", transformOrigin: "252.558px 355.03px" }}
            d="M200.35,337.5s36.77.54,69.17,8.69c15.53,3.9,45,10.52,45,10.52l-5.71,11.52s-18.76,1.39-49.21-3.93c-20.54,7.56-38.88,8.26-69,8.26C190.39,353.63,200.35,337.5,200.35,337.5Z"
          />
        </g>
        <g id="elwd558z3wwqq">
          <path
            className="animable"
            style={{ opacity: "0.2", transformOrigin: "145.147px 296.085px" }}
            d="M149.28,290.71l-10.91,6c-.51.83,2,4.2,6.3,4.69a12.76,12.76,0,0,0,7.32-1.48C149.82,297.18,148.22,293.56,149.28,290.71Z"
          />
        </g>
        <path
          className="animable"
          id="elticwdynbild"
          style={{
            fill: "rgb(11, 229, 179)",
            transformOrigin: "84.0093px 315.615px",
          }}
          d="M77.49,327.08a21.88,21.88,0,0,1,3.44-15.93,19.43,19.43,0,0,1,9.59-7l.32.94a18.23,18.23,0,0,0-9.09,6.66,20.83,20.83,0,0,0-3.27,15.21Z"
        />
        <path
          className="animable"
          id="el172g86if5y3"
          style={{
            fill: "rgb(11, 229, 179)",
            transformOrigin: "221.021px 349.085px",
          }}
          d="M354,370.65H198.55l-13.29-39.28c-4.67-13.83-19.67-25-33.5-25H98.67c-13.82,0-21.24,11.21-16.57,25l13.31,39.34a31,31,0,0,0,29.38,21.09H354a7.34,7.34,0,0,0,7.34-7.34V378A7.34,7.34,0,0,0,354,370.65Z"
        />
        <path
          className="animable"
          id="elcy0ci8p8307"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "149.126px 277.295px",
          }}
          d="M148.32,271.94c.82,3.27,4.47,6.56,5.54,7.88s-4.26,2.83-4.26,2.83l-5.35-5.79Z"
        />
        <path
          className="animable"
          id="ellge9m9b4qx"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "171.811px 293.685px",
          }}
          d="M151.88,298l2,.12,2.18.1c1.47,0,2.94.11,4.41.12,2.94,0,5.86,0,8.7-.19,1.42-.09,2.83-.21,4.2-.38s2.73-.34,4-.6a31.63,31.63,0,0,0,6.92-2.06l-3.5,3.78c1.05-1.91,2.13-3.91,3.13-6s2-4.27,3-6.48,1.92-4.45,2.89-6.71,1.92-4.58,2.91-6.76l.09-.2a4.78,4.78,0,0,1,9.13,1.91c0,2.75-.12,5.31-.34,7.95s-.6,5.22-1,7.83-1,5.23-1.71,7.85a72.17,72.17,0,0,1-2.59,7.91,7,7,0,0,1-2.82,3.37l-.68.41a42.84,42.84,0,0,1-11,4.74,66.27,66.27,0,0,1-10.79,2.11,89.42,89.42,0,0,1-10.54.61c-1.74,0-3.48,0-5.22-.14-.87,0-1.75-.1-2.62-.18l-1.33-.13-1.45-.17A9.45,9.45,0,0,1,151.36,298Z"
        />
        <path
          className="animable"
          id="elgc6w43z2pl6"
          style={{
            fill: "rgb(11, 229, 179)",
            transformOrigin: "197.29px 275.671px",
          }}
          d="M198.55,270.11c-5.13-1.15-6.11,1.95-6.61,4.39s1.29,5.85,5.35,6.79,4.74-1.86,4.93-3.33S204.48,271.44,198.55,270.11Z"
        />
        <path
          className="animable"
          id="elpmqeuuszp9i"
          style={{
            fill: "rgb(181, 91, 82)",
            transformOrigin: "198.916px 272.55px",
          }}
          d="M201,277.36l3.76-2.34-6.58-7.88s-6.29,3.31-4.91,6.85l2.88,2.84A3.94,3.94,0,0,0,201,277.36Z"
        />
        <path
          className="animable"
          id="ell77qa1ad66g"
          style={{
            fill: "rgb(181, 91, 82)",
            transformOrigin: "196.654px 268.092px",
          }}
          d="M193.25,273.82c-1.16-6,4.33-7.72,4.82-10.76a.74.74,0,0,1,1.46-.12,4.73,4.73,0,0,1-.42,3.49c-.72.84,3.07,5.35-.33,7.36A16.69,16.69,0,0,0,193.25,273.82Z"
        />
        <path
          className="animable"
          id="elwr889nzc81i"
          style={{
            fill: "rgb(181, 91, 82)",
            transformOrigin: "203.476px 269.669px",
          }}
          d="M208,267.2l-1.05-1.38a3.8,3.8,0,0,0-5-.95l-3.76,2.27,6.58,7.88,2.86-2.83A3.8,3.8,0,0,0,208,267.2Z"
        />
        <path
          className="animable"
          id="elsxnsd5yiz1g"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "317.677px 359.971px",
          }}
          d="M311.46,369c-1.2-2-3.61-1.48-6.34-2,0,0,4.53-11.7,7-10.26,5.06,3,11-1.36,16.33-7.39.74-.84,2.64,1.76,1.34,4-3.25,5.64-7.92,8-10.35,10.79-2.08,2.37-2.09,4.22-4.07,5.81C313.72,371.25,312.65,371,311.46,369Z"
        />
        <path
          className="animable"
          id="eli3ym4buzdjk"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "291.41px 363.603px",
          }}
          d="M278.46,367.29c.59-2.26,1.18-5.43-.34-7.76,0,0,11.5-5,12.22-2.25,1.46,5.67,2.84,8.29,12.57,10,1.1.2,3.12,3.44.52,3.44-7.52,0-12.22-.81-15.89-.59-3.15.18-4.46.84-7,.55C278.47,370.48,277.86,369.57,278.46,367.29Z"
        />
        <path
          className="animable"
          id="el4w89oqpfn03"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "168.201px 336.331px",
          }}
          d="M155.56,300.25c-8.88-.73-20.43,1.23-27.13,6.35a13.65,13.65,0,0,0-5.18,14.1c5.34,21.86,33.2,51.86,67.33,51.86l22.89-42.7s2.53-15.95-31-14.26C172.87,305.73,164.38,301,155.56,300.25Z"
        />
        <path
          className="animable"
          id="elmm0igx1a058"
          style={{
            fill: "rgb(11, 229, 179)",
            transformOrigin: "243.28px 336.965px",
          }}
          d="M210.24,326.71a296,296,0,0,1,59.59-14.79c18.26-2.5,21.58,48,21.58,48l-13.29,2.18c-2.45-14.06-10.1-17.87-13.49-28.49-14.26,13.28-45.83,24.75-69.48,15.12,3.62-9.43,4.95-10.92,8.6-16.56C206.84,327.44,210.24,326.71,210.24,326.71Z"
        />
        <path
          className="animable"
          id="elmqr16brpoa"
          style={{
            fill: "rgb(11, 229, 179)",
            transformOrigin: "252.558px 355.03px",
          }}
          d="M200.35,337.5s36.77.54,69.17,8.69c15.53,3.9,45,10.52,45,10.52l-5.71,11.52s-18.76,1.39-49.21-3.93c-20.54,7.56-38.88,8.26-69,8.26C190.39,353.63,200.35,337.5,200.35,337.5Z"
        />
        <path
          className="animable"
          id="elatuox8fqthv"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "143.054px 341.427px",
          }}
          d="M141.4,319.59l-.94,8.93c-.32,3-.57,6-.83,9-.11,1.49-.23,3-.3,4.47s-.17,3-.24,4.43c-.08,2.92-.13,5.8,0,8.54L137,350.3a24.49,24.49,0,0,0,4.37,4.4c.89.67,1.83,1.36,2.82,2s2.06,1.26,3.15,1.86a68.07,68.07,0,0,0,6.93,3.26c1.21.49,2.43,1,3.68,1.42.62.23,1.24.46,1.87.66l1.77.62.53.19a4.71,4.71,0,0,1-1.32,9.15c-.93.05-1.63.09-2.44.1s-1.55,0-2.32,0c-1.55-.06-3.09-.16-4.64-.33a57.62,57.62,0,0,1-9.28-1.82,47.14,47.14,0,0,1-9.21-3.72,43.58,43.58,0,0,1-4.47-2.8,35.47,35.47,0,0,1-4.19-3.63,6.89,6.89,0,0,1-2-3.84l-.14-.85A93.8,93.8,0,0,1,121,346.63c-.18-3.38-.2-6.72-.13-10s.28-6.59.55-9.86c.15-1.63.3-3.26.51-4.89s.42-3.21.7-5a9.46,9.46,0,0,1,18.75,2.49Z"
        />
        <path
          className="animable"
          id="elicm8bybopls"
          style={{
            fill: "rgb(11, 229, 179)",
            transformOrigin: "160.369px 369.964px",
          }}
          d="M165.16,373.52c4.06-3.14,1.34-6.55-.66-8.06a7.23,7.23,0,0,0-9.46,1.08c-2.37,2.41-1.67,6.87-.37,7.59S159.73,377.71,165.16,373.52Z"
        />
        <path
          className="animable"
          id="el0hmy52683g8q"
          style={{
            fill: "rgb(181, 91, 82)",
            transformOrigin: "162.657px 372.237px",
          }}
          d="M164.77,367.74l3.44,2.17-6.28,7.43s-6-3.18-4.62-6.52l2.64-2.57A3.9,3.9,0,0,1,164.77,367.74Z"
        />
        <path
          className="animable"
          id="ele2cb42s04ah"
          style={{
            fill: "rgb(181, 91, 82)",
            transformOrigin: "166.939px 374.977px",
          }}
          d="M171.2,377.34l-1,1.3a3.59,3.59,0,0,1-4.73.87l-3.54-2.17,6.28-7.43,2.69,2.7A3.59,3.59,0,0,1,171.2,377.34Z"
        />
        <path
          className="animable"
          id="elcfla751rl4i"
          style={{
            fill: "rgb(181, 91, 82)",
            transformOrigin: "144.599px 298.086px",
          }}
          d="M130,285.12c2.41,5.21,5.58,14.45,3,20.1a3.27,3.27,0,0,0,1.5,4.27c2.57,1.28,7.23,2.33,15.28.81,9.85-1.86,10.16-4.31,8.88-5.95a5.71,5.71,0,0,0-4.09-1.85c-3.24-2.57-6.8-8.05-5.21-11.95Z"
        />
        <path
          className="animable"
          id="elp0rea33rlqn"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "142.614px 269.837px",
          }}
          d="M149.38,270.47c-.33-5.66-4.06-7.72-4.06-7.72a7.81,7.81,0,0,0-.93,5.91l-8.55,6.85C139.53,278.76,149.71,276.13,149.38,270.47Z"
        />
        <path
          className="animable"
          id="el320guzwy972"
          style={{
            fill: "rgb(181, 91, 82)",
            transformOrigin: "140.278px 283.793px",
          }}
          d="M127.59,285c4.1,7.5,6.12,12.09,11.87,14.22,8.66,3.2,16.53-4.8,14.75-13.37-1.6-7.71-8-18.67-17-18.19A11.64,11.64,0,0,0,127.59,285Z"
        />
        <path
          className="animable"
          id="elv64cbws4q28"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "141.051px 281.293px",
          }}
          d="M140.31,281.64c.29.63.87,1,1.28.79s.5-.86.21-1.49-.87-1-1.28-.78S140,281,140.31,281.64Z"
        />
        <path
          className="animable"
          id="elit460q4f5kc"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "148.153px 277.96px",
          }}
          d="M147.41,278.31c.29.63.87,1,1.28.79s.5-.86.21-1.49-.87-1-1.28-.79S147.11,277.68,147.41,278.31Z"
        />
        <path
          className="animable"
          id="elbpywm3eny8p"
          style={{
            fill: "rgb(160, 39, 36)",
            transformOrigin: "148.06px 282.68px",
          }}
          d="M145.3,279.68a24.9,24.9,0,0,0,5.52,4c-.62,1.56-2.73,2-2.73,2Z"
        />
        <path
          className="animable"
          id="el07mdib8aavw3"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "145.332px 289.181px",
          }}
          d="M143.94,289a6.53,6.53,0,0,0-1.18,1,.21.21,0,0,0,.3.28,5.49,5.49,0,0,1,4.64-1.79.2.2,0,0,0,.23-.16.21.21,0,0,0-.16-.24A5.6,5.6,0,0,0,143.94,289Z"
        />
        <path
          className="animable"
          id="elz143jfyo9d"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "136.613px 278.953px",
          }}
          d="M136.53,277a.39.39,0,0,0-.13.42,3.25,3.25,0,0,1-.46,2.91.42.42,0,0,0,.05.58.41.41,0,0,0,.57-.05,4,4,0,0,0,.62-3.67.4.4,0,0,0-.5-.27A.28.28,0,0,0,136.53,277Z"
        />
        <path
          className="animable"
          id="el0qd7xu5hbyib"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "147.716px 273.298px",
          }}
          d="M146.08,272.37a.37.37,0,0,0-.24.12.41.41,0,0,0,0,.58,4,4,0,0,0,3.56,1.09.4.4,0,0,0,.3-.49.41.41,0,0,0-.49-.3,3.22,3.22,0,0,1-2.81-.9A.4.4,0,0,0,146.08,272.37Z"
        />
        <path
          className="animable"
          id="elummrs1gdfv"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "134.382px 286.92px",
          }}
          d="M132.53,282.93c.85,3.26,4.51,3.8,5.59,5.11s-4.23,2.87-4.23,2.87l-3.39-2.75Z"
        />
        <path
          className="animable"
          id="elpo1brv9a7d"
          style={{
            fill: "rgb(181, 91, 82)",
            transformOrigin: "129.846px 290.222px",
          }}
          d="M126.55,292.42a8.47,8.47,0,0,0,5.86,1.85c2.75-.24,3-2.9,1.27-5-1.54-1.87-4.83-4-7.13-2.73S124.5,290.76,126.55,292.42Z"
        />
        <path
          className="animable"
          id="el9cnzclyayl"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "126.962px 276.894px",
          }}
          d="M131.81,287.59c2.1-2.4-.24-9.28-1.29-10.72,1.22-1,5.94-6.24,3.35-9.44s-9.24,0-9.24,0a3.15,3.15,0,0,0,2.15,1.75c-2.93.88-7,3-7.49,6.75,2.76,0,2.85-.44,2.85-.44s-3.86,6.59-2,10.13a1.79,1.79,0,0,0,1.8-1.85S123.29,288.81,131.81,287.59Z"
        />
        <path
          className="animable"
          id="el2hye9puhqeg"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "133.984px 269.35px",
          }}
          d="M137.9,264.46c-3.81-4.21-9-2.11-9-2.11a4.38,4.38,0,0,0,2.58,4.16l-1,10.36C135.42,277.09,141.71,268.66,137.9,264.46Z"
        />
        <path
          className="animable"
          id="el73395ct1h4f"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "138.19px 266.955px",
          }}
          d="M144.56,266.37c-1.06-5.57-6.57-6.47-6.57-6.47a4.37,4.37,0,0,0,0,4.89l-6.25,8.32C135.85,275.86,145.62,271.94,144.56,266.37Z"
        />
        <path
          className="animable"
          id="elea1183vgh8a"
          style={{
            fill: "rgb(11, 229, 179)",
            transformOrigin: "201.125px 348.007px",
          }}
          d="M193.33,372.56c-2,1-4.91,0-4.91,0s-1.56-37.77,22.9-49.55c1.53,0,2.53,2.39,2.53,2.39a47.46,47.46,0,0,0-16,21.71C192.67,361.56,193.33,372.56,193.33,372.56Z"
        />
        <polygon
          className="animable"
          id="el4xlnszfzeql"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "269.265px 401.51px",
          }}
          points="270.13 411.22 265.49 411.22 265.49 391.8 273.04 391.8 270.13 411.22"
        />
        <polygon
          className="animable"
          id="elkchero4geps"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "350.2px 401.51px",
          }}
          points="349.34 411.22 353.98 411.22 353.98 391.8 346.42 391.8 349.34 411.22"
        />
        <polygon
          className="animable"
          id="elu4hupucxh4"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "134.165px 401.51px",
          }}
          points="135.03 411.22 130.39 411.22 130.39 391.8 137.94 391.8 135.03 411.22"
        />
        <polygon
          className="animable"
          id="el5ri7lq5jq8l"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "215.095px 401.51px",
          }}
          points="214.23 411.22 218.87 411.22 218.87 391.8 211.32 391.8 214.23 411.22"
        />
      </g>
      <g
        className="animable"
        id="freepik--character-2--inject-10"
        style={{ transformOrigin: "342.217px 269.658px" }}
      >
        <path
          className="animable"
          id="el7nugada8tjb"
          style={{
            fill: "rgb(255, 195, 189)",
            transformOrigin: "349.149px 163.95px",
          }}
          d="M357.83,148.65c-1.11,5.67-2.22,16.07,1.75,19.85a42.1,42.1,0,0,0-19.46,10.75c-4-7.4,1.83-10.75,1.83-10.75,6.32-1.51,6.16-6.2,5.06-10.61Z"
        />
        <path
          className="animable"
          id="el8ffclwd75nk"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "352.495px 168.555px",
          }}
          d="M341.89,173.62c1.3-5.25-2.6-6.06,3.84-8.56,5-2,14.62-2.06,16.9-.35,1.27,1-.4,4.18-.4,4.18Z"
        />
        <path
          className="animable"
          id="els0gan49p54"
          style={{
            fill: "rgb(255, 195, 189)",
            transformOrigin: "357.587px 194.359px",
          }}
          d="M371.63,173.4c.21.5.32.78.47,1.15l.4,1c.26.69.47,1.38.69,2.06.43,1.38.81,2.76,1.15,4.14a59,59,0,0,1,1.42,8.47,51.06,51.06,0,0,1-1.21,17.41c-.19.71-.37,1.43-.61,2.14l-.16.53-.09.27-.14.42a8.48,8.48,0,0,1-1.13,2.16,10.07,10.07,0,0,1-2.81,2.62,14.87,14.87,0,0,1-2.62,1.31,31.31,31.31,0,0,1-9,1.75,73.85,73.85,0,0,1-16.4-.93,2.93,2.93,0,0,1,.15-5.8h.11a145.41,145.41,0,0,0,14.9-2.23,34.61,34.61,0,0,0,3.38-.9,15.66,15.66,0,0,0,2.8-1.12c.74-.37,1.17-.93.82-.64a1.48,1.48,0,0,0-.25.42l0,.06,0-.11.05-.2.09-.42c.14-.54.23-1.1.34-1.66a45.73,45.73,0,0,0,.15-13.78,64.05,64.05,0,0,0-1.3-7c-.28-1.15-.6-2.3-.94-3.42l-.54-1.66-.28-.8-.24-.67-.11-.29a5.87,5.87,0,0,1,10.9-4.35Z"
        />
        <path
          className="animable"
          id="ele26p8bbuvy7"
          style={{
            fill: "rgb(255, 195, 189)",
            transformOrigin: "339.79px 213.6px",
          }}
          d="M343.25,218l-8.86-1,3.2-7.8a51.32,51.32,0,0,1,7.6,4.22Z"
        />
        <path
          className="animable"
          id="elo7iobwl4oi"
          style={{
            fill: "rgb(255, 195, 189)",
            transformOrigin: "334.189px 212.879px",
          }}
          d="M331,212.86l1.94-3.21a1.92,1.92,0,0,1,2-.9l2.7.49-3.2,7.8-2.71-1.53A1.92,1.92,0,0,1,331,212.86Z"
        />
        <path
          className="animable"
          id="elzp8xbm52oa8"
          style={{
            fill: "rgb(11, 229, 179)",
            transformOrigin: "369.256px 182.745px",
          }}
          d="M368.9,169.4c4.38,3,7.52,8.91,9.62,19.82-2,3.92-15.88,8.13-15.88,8.13S353.61,161,368.9,169.4Z"
        />
        <path
          className="animable"
          id="elpeoddzlc08"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "316.605px 199.72px",
          }}
          d="M339.23,218.38l-25.82,5.21a3.79,3.79,0,0,1-4-2.08l-17-37.26a2.17,2.17,0,0,1,1.57-3.19l25.82-5.21a3.79,3.79,0,0,1,4,2.08l17,37.26A2.17,2.17,0,0,1,339.23,218.38Z"
        />
        <path
          className="animable"
          id="el787k1uyn1pr"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "316.955px 198.965px",
          }}
          d="M313,221.17a1.4,1.4,0,0,1-1.47-.77l-17-37.26a.79.79,0,0,1,.57-1.17l25.82-5.21a1.39,1.39,0,0,1,1.46.76l17,37.26a.8.8,0,0,1-.57,1.18Z"
        />
        <path
          className="animable"
          id="el0slhwihrrspg"
          style={{
            fill: "rgb(11, 229, 179)",
            transformOrigin: "309.883px 186.504px",
          }}
          d="M306.72,192.05a1.08,1.08,0,0,1-.87-1.69l6.35-9a1.07,1.07,0,0,1,1.74,1.24l-6.34,9A1.09,1.09,0,0,1,306.72,192.05Z"
        />
        <path
          className="animable"
          id="elub8whe6jdws"
          style={{
            fill: "rgb(11, 229, 179)",
            transformOrigin: "347.929px 197.414px",
          }}
          d="M324.75,181.87c.16,3.82-5.86,12.65,1.58,17.77.87,7.71,2,15.3,4,28h38.83c-4.14-14-1.25-23.41,3.89-48a9.82,9.82,0,0,0-8.62-11.77c-1.55-.16-3.19-.29-4.87-.37a124.84,124.84,0,0,0-17.63,0c-1.91.18-3.88.42-5.76.68A13.32,13.32,0,0,0,324.75,181.87Z"
        />
        <path
          className="animable"
          id="elt4gi6mwaxi"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "348.876px 222.99px",
          }}
          d="M329.3,222.4a4.49,4.49,0,0,0,.7,3,132.19,132.19,0,0,1,38.35-1,4.61,4.61,0,0,0-.19-2.8S351.74,218.84,329.3,222.4Z"
        />
        <path
          className="animable"
          id="el8w1zgq8dp0y"
          style={{
            fill: "rgb(255, 195, 189)",
            transformOrigin: "306.39px 196.485px",
          }}
          d="M309.43,199.45l1-8.18-8.08,2.43a52.68,52.68,0,0,0,3.47,8Z"
        />
        <path
          className="animable"
          id="elzk7f4g6qj58"
          style={{
            fill: "rgb(255, 195, 189)",
            transformOrigin: "306.282px 190.498px",
          }}
          d="M306.61,187.48l-3.39,1.61a1.9,1.9,0,0,0-1.08,1.87l.21,2.74,8.08-2.43-1.26-2.85A1.91,1.91,0,0,0,306.61,187.48Z"
        />
        <path
          className="animable"
          id="el3iwr2tt56gc"
          style={{
            fill: "rgb(255, 195, 189)",
            transformOrigin: "321.996px 192.833px",
          }}
          d="M339.29,179.82c-.39,1.51-.76,2.8-1.19,4.16s-.87,2.67-1.33,4c-.95,2.63-2,5.24-3.12,7.81s-2.37,5.12-3.71,7.62-2.83,4.94-4.41,7.34l-.2.31a4.85,4.85,0,0,1-3.58,2.16,14.77,14.77,0,0,1-6.83-1,15.48,15.48,0,0,1-5.26-3.64,19.92,19.92,0,0,1-3.23-4.64,24,24,0,0,1-1.06-2.46,22.6,22.6,0,0,1-.75-2.64,2.91,2.91,0,0,1,5-2.56l.39.45c.35.4.82,1,1.25,1.49s.89,1,1.35,1.45a15,15,0,0,0,2.81,2.23,6.75,6.75,0,0,0,2.61,1,5.6,5.6,0,0,0,2.23-.17l-3.78,2.46c1.2-2.21,2.34-4.46,3.4-6.79s2.07-4.68,3-7.08,1.84-4.82,2.68-7.26l1.22-3.67c.39-1.2.8-2.49,1.13-3.58l0-.13a5.87,5.87,0,0,1,11.31,3.15Z"
        />
        <path
          className="animable"
          id="elu43hhubf0uq"
          style={{
            fill: "rgb(11, 229, 179)",
            transformOrigin: "331.222px 182.852px",
          }}
          d="M332.92,169c-4.82,2.24-9.59,6.68-11.53,17.18,1.28,4.19,14.36,11.16,14.36,11.16S349.39,163.34,332.92,169Z"
        />
        <path
          className="animable"
          id="elu2z1fma2yd"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "332.251px 143.589px",
          }}
          d="M333.15,143.42c.15.75-.13,1.45-.62,1.54s-1-.43-1.17-1.19.13-1.45.62-1.55S333,142.66,333.15,143.42Z"
        />
        <path
          className="animable"
          id="eldl3ttgey3k7"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "331.25px 142.359px",
          }}
          d="M332.21,142.22l-1.92-.16S331.5,143.29,332.21,142.22Z"
        />
        <path
          className="animable"
          id="eldab7qtra6oc"
          style={{
            fill: "rgb(237, 132, 126)",
            transformOrigin: "332.665px 147.094px",
          }}
          d="M333,144.26a20.47,20.47,0,0,1-1.73,5.36,3.32,3.32,0,0,0,2.79,0Z"
        />
        <path
          className="animable"
          id="elqrmza0eth7"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "331.853px 142.855px",
          }}
          d="M332.81,149a4,4,0,0,1-2.59-1.14A8.36,8.36,0,0,1,327.9,144c-.95-3.36.06-6.6,2.24-7.21a3.57,3.57,0,0,1,3.34,1,8.4,8.4,0,0,1,2.33,3.95c.94,3.36-.06,6.59-2.24,7.2A2.79,2.79,0,0,1,332.81,149Zm-1.92-11.89a2.57,2.57,0,0,0-.62.08c-1.91.54-2.76,3.5-1.89,6.59a7.81,7.81,0,0,0,2.18,3.71,3.07,3.07,0,0,0,2.87.92c1.92-.54,2.77-3.49,1.9-6.59h0a8,8,0,0,0-2.18-3.71A3.47,3.47,0,0,0,330.89,137.14Z"
        />
        <path
          className="animable"
          id="elebbjka8292w"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "332.324px 138.499px",
          }}
          d="M330.59,139.63a.39.39,0,0,1-.32-.12.46.46,0,0,1,0-.64,4.52,4.52,0,0,1,3.86-1.48.46.46,0,0,1,.37.53.44.44,0,0,1-.52.36,3.61,3.61,0,0,0-3,1.21A.45.45,0,0,1,330.59,139.63Z"
        />
        <path
          className="animable"
          id="els7xf85h4nwj"
          style={{
            fill: "rgb(255, 195, 189)",
            transformOrigin: "345.351px 142.811px",
          }}
          d="M357.66,136c1.28,9.4,2,13.35-1.63,19-5.49,8.54-17.1,8-21.12-.83-3.62-8-5.11-22,3.07-27.46S356.37,126.57,357.66,136Z"
        />
        <path
          className="animable"
          id="el40f5n5oluqb"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "352.259px 140.942px",
          }}
          d="M343.74,156.11c5.87,2.83,17.49,1.06,21.3-7.46s-.13-20.52-9-23.16c-8.73-2.58-16.52-.1-17.65,8.85S338.7,153.68,343.74,156.11Z"
        />
        <path
          className="animable"
          id="el09fgjtd4tzab"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "337.171px 143.514px",
          }}
          d="M328.14,144.13a.25.25,0,0,1-.25-.23.25.25,0,0,1,.22-.27c.12,0,12-1.17,18.12-.55a.25.25,0,0,1,.22.28.24.24,0,0,1-.27.22c-6.07-.61-17.9.53-18,.55Z"
        />
        <path
          className="animable"
          id="elqcx26v6i6l"
          style={{
            fill: "rgb(255, 195, 189)",
            transformOrigin: "346.496px 319.75px",
          }}
          d="M330.35,227.59s-.07,50.87,3.79,83.17c.61,30.33,4.07,101.15,4.07,101.15h7.65s11.88-60.36,8.14-96.27c15.58-51.3,5.34-88,5.34-88Z"
        />
        <path
          className="animable"
          id="elijvbotjkdad"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "335.335px 412.815px",
          }}
          d="M337.91,405.65c-2.23,2.27-4.49,9.07-11.94,11.33-4.83,1.46-2.9,3,4.39,3,8.43,0,10.76-3.67,13.61-3.67s4.49-1.84,2.53-7.89C340.15,407.64,337.91,405.65,337.91,405.65Z"
        />
        <path
          className="animable"
          id="elbhawma2eoko"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "344.66px 415.52px",
          }}
          d="M347.13,411.1a39.18,39.18,0,0,1-.13,8.84h-2.31L342,414.08Z"
        />
        <path
          className="animable"
          id="elikcc03l3v5"
          style={{
            fill: "rgb(255, 195, 189)",
            transformOrigin: "366.396px 319.775px",
          }}
          d="M340.5,227.59s15.89,59.34,24.89,87c9.46,29,18.32,95.18,18.34,97.37h6.62s6.84-53.64-5.15-97.4c-3.24-71-16-86.92-16-86.92Z"
        />
        <path
          className="animable"
          id="elo1san57aco"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "381.905px 413.325px",
          }}
          d="M383.12,406.67c-1.7,2.83-3.66,9-8.22,10.31s-2.72,3,4.12,3c4.64,0,6-3.67,8.64-3.67s4.94-1.85,3.08-7.9C385.19,409,383.12,406.67,383.12,406.67Z"
        />
        <path
          className="animable"
          id="elqg72d7xyw0c"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "388.317px 415.655px",
          }}
          d="M391.38,411.37a49.12,49.12,0,0,1-.09,8.57h-3.8l-2.38-5.86Z"
        />
        <path
          className="animable"
          id="elrvmyt55x1z"
          style={{
            fill: "rgb(127, 62, 59)",
            transformOrigin: "338.778px 145.345px",
          }}
          d="M341.87,145.19a6.07,6.07,0,0,1-2.52,4.33c-1.82,1.2-3.52-.67-3.68-3.08-.15-2.17.63-5.42,2.78-5.63S342.16,142.92,341.87,145.19Z"
        />
        <path
          className="animable"
          id="elulq0jp4yn2k"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "349.265px 140.938px",
          }}
          d="M366.9,151.22c-4.9-2.3-17.26,1.81-26,8.46a27.22,27.22,0,0,1-3.73-8.57,32.67,32.67,0,0,0,2.35,9.65c-.73.58-1.42,1.18-2.07,1.78-1.85-4.6-4.06-16.44-3.61-25.86-.78-.74-2.61-.61-3.72-1.48.67-12.63,14.28-16,19.44-15.86a18.27,18.27,0,0,1,10.49,3.21C367.52,128,370.47,141.67,366.9,151.22Z"
        />
        <path
          className="animable"
          id="elb30go3nwhzi"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "359.067px 276.847px",
          }}
          d="M330.35,227.59s-.86,39.91,2.12,99.94c28.12-2.14,55.43-19.93,55.43-19.93s-.82-63.36-18.72-80C359.07,224.89,330.55,226.68,330.35,227.59Z"
        />
        <g id="elqlit5xkt1h">
          <path
            className="animable"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: "349.265px 140.938px",
            }}
            d="M366.9,151.22c-4.9-2.3-17.26,1.81-26,8.46a27.22,27.22,0,0,1-3.73-8.57,32.67,32.67,0,0,0,2.35,9.65c-.73.58-1.42,1.18-2.07,1.78-1.85-4.6-4.06-16.44-3.61-25.86-.78-.74-2.61-.61-3.72-1.48.67-12.63,14.28-16,19.44-15.86a18.27,18.27,0,0,1,10.49,3.21C367.52,128,370.47,141.67,366.9,151.22Z"
          />
        </g>
        <g id="el40giuqf97g2">
          <g
            className="animable"
            style={{ opacity: "0.2", transformOrigin: "359.715px 318.225px" }}
          >
            <path
              className="animable"
              id="el9ekdgvvbjva"
              style={{ transformOrigin: "344.555px 325.13px" }}
              d="M334.43,321.9c.1,3.42.21,7.07.35,10.87a118.57,118.57,0,0,0,19.9-5.85c-.07-3.26-.24-6.43-.5-9.43A102.37,102.37,0,0,1,334.43,321.9Z"
            />
            <path
              className="animable"
              id="el379bxn0xfp6"
              style={{ transformOrigin: "375px 312.505px" }}
              d="M384.59,303.68A157.46,157.46,0,0,1,365,313.47c.12.36.23.72.35,1.07.68,2.08,1.35,4.36,2,6.79A174.72,174.72,0,0,0,385,311.39Q384.85,307.42,384.59,303.68Z"
            />
          </g>
        </g>
      </g>
      <g
        className="animable"
        id="freepik--speech-bubbles--inject-10"
        style={{ transformOrigin: "211.351px 148.337px" }}
      >
        <path
          className="animable"
          id="elnu6qfay5q7"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "171.316px 184.543px",
          }}
          d="M156.53,251.14a.59.59,0,0,1-.26-.07.5.5,0,0,1-.24-.5c.94-6.81-1.47-17.17-8.95-25-18.82-4.5-32.65-16.23-38-32.2-9.28-28,11.07-60,45.38-71.38s69.78,2.08,79.07,30c4.5,13.56,2.25,28.46-6.34,41.95s-22.44,23.91-39,29.43a80,80,0,0,1-18.81,3.83c1.24,13.28-12.41,23.72-12.55,23.83A.57.57,0,0,1,156.53,251.14Zm22.64-132.23a77.53,77.53,0,0,0-24.35,4C121,134.14,101,165.59,110.07,193c5.21,15.67,18.83,27.17,37.38,31.57a.48.48,0,0,1,.25.14c7.35,7.66,10,17.68,9.45,24.73,3.06-2.62,12.52-11.72,11.18-22.66a.49.49,0,0,1,.11-.38.52.52,0,0,1,.35-.18,78.2,78.2,0,0,0,19.09-3.82c16.38-5.44,30.06-15.75,38.51-29s10.64-27.83,6.23-41.1C225.71,131.52,204,118.91,179.17,118.91Z"
        />
        <path
          className="animable"
          id="elfe6kklnx3e8"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "273.008px 83.5318px",
          }}
          d="M306.14,121.5h-.07c-.46-.06-11.2-1.69-14.78-9.64a52,52,0,0,1-11.88,3.68c-11.3,2.08-22.58.46-31.78-4.58s-15.25-12.92-17-22.18c-3.51-19,12.64-38.06,36-42.37s45.24,7.7,48.75,26.76c2,10.87-2.23,22-11.62,30.56-1.78,6.8.09,13.42,2.74,17a.5.5,0,0,1-.4.8Zm-14.59-10.82a.41.41,0,0,1,.19,0,.48.48,0,0,1,.28.28c2.52,6.3,10.11,8.6,13,9.27a22.36,22.36,0,0,1-2.18-17,.41.41,0,0,1,.15-.24c9.2-8.33,13.36-19.17,11.42-29.74-3.42-18.52-24.75-30.16-47.58-26s-38.62,22.7-35.21,41.21c1.65,9,7.5,16.58,16.46,21.49s20.05,6.51,31.12,4.47a51.31,51.31,0,0,0,12.11-3.82A.54.54,0,0,1,291.55,110.68Z"
        />
        <path
          className="animable"
          id="elnfktrcapxwf"
          style={{
            fill: "rgb(11, 229, 179)",
            transformOrigin: "212.779px 134.421px",
          }}
          d="M176.27,211.91c-.81,0-1.62,0-2.44,0-8.69-.33-17.85-2.29-28.83-6.19-4.15-1.47-8.81-3.35-11.69-7.12a16.91,16.91,0,0,1-2.19-3.93,28.55,28.55,0,0,1-1.74-14.69c-.1-1.07-.2-2.14-.29-3.2-.05-.64-.11-1.29-.16-1.93l-.18-1.87c-.59-6.17-1.2-12.55,1.07-18.34S136.61,145.13,140,143a52.17,52.17,0,0,1,14.41-5.74c3.86-1,7.53-1.82,11.06-2.42a13.62,13.62,0,0,1,1.89-.89c3.44-1.32,7.26-1.18,10.53-.86.94.09,1.91.2,2.9.35,1.18,0,2.34,0,3.49.09A18.31,18.31,0,0,1,196.9,140a21.65,21.65,0,0,1,5.23,16A40.75,40.75,0,0,1,214,176.07c13.56-2.06,28.32-8.34,38.64-16.92,15.22-12.64,26.77-25.51,37.36-50.52,8.52-20.12,8.8-34.13.88-42.82a25.09,25.09,0,0,0-35.43-1.63,23.87,23.87,0,0,0-1.55,33.72A22.73,22.73,0,0,0,286,99.38a21.63,21.63,0,0,0,1.4-30.54,20.58,20.58,0,0,0-29.05-1.33,19.59,19.59,0,0,0-1.27,27.64,18.62,18.62,0,0,0,26.3,1.21,17.7,17.7,0,0,0,1.15-25,16.87,16.87,0,0,0-23.81-1.1,16.05,16.05,0,0,0-1,22.65,15.25,15.25,0,0,0,21.55,1,14.51,14.51,0,0,0,.94-20.49,13.79,13.79,0,0,0-19.49-.9A13.14,13.14,0,0,0,261.8,91a12.51,12.51,0,0,0,17.64.81,11.89,11.89,0,0,0,.77-16.77,11.29,11.29,0,0,0-15.95-.73,10.72,10.72,0,0,0-.69,15.16,10.21,10.21,0,0,0,14.41.66,9.7,9.7,0,0,0,.63-13.7,9.23,9.23,0,0,0-13-.6A8.77,8.77,0,0,0,265,88.24a8.33,8.33,0,0,0,11.76.54,7.93,7.93,0,0,0,.51-11.18,7.52,7.52,0,0,0-10.62-.48,7.13,7.13,0,0,0-.46,10.08,6.78,6.78,0,0,0,9.58.45,6.46,6.46,0,0,0,.42-9.11,6.13,6.13,0,0,0-4.24-2,6.05,6.05,0,0,0-4.4,1.6.39.39,0,0,1-.53,0,.38.38,0,0,1,0-.53A6.83,6.83,0,0,1,272,75.81,6.76,6.76,0,0,1,276.76,78a7.19,7.19,0,0,1-.46,10.16,7.55,7.55,0,0,1-10.65-.49,7.9,7.9,0,0,1,.52-11.15,8.28,8.28,0,0,1,11.68.54,8.68,8.68,0,0,1-.57,12.24,9.09,9.09,0,0,1-12.82-.59,9.53,9.53,0,0,1,.62-13.44,10,10,0,0,1,14.08.65,10.44,10.44,0,0,1-.68,14.76A11,11,0,0,1,263,90a11.48,11.48,0,0,1,.75-16.21,12,12,0,0,1,17,.78,12.62,12.62,0,0,1-.82,17.82,13.24,13.24,0,0,1-18.69-.86,13.88,13.88,0,0,1,.9-19.59,14.54,14.54,0,0,1,20.55.94,15.25,15.25,0,0,1-1,21.55,16,16,0,0,1-22.6-1,16.8,16.8,0,0,1,1.09-23.71,17.59,17.59,0,0,1,24.86,1.14,18.45,18.45,0,0,1-1.19,26.08,19.38,19.38,0,0,1-27.37-1.25A20.36,20.36,0,0,1,257.82,67a21.34,21.34,0,0,1,30.12,1.39,22.37,22.37,0,0,1-1.46,31.59,23.46,23.46,0,0,1-33.14-1.53,24.62,24.62,0,0,1,1.6-34.77,25.82,25.82,0,0,1,36.49,1.68c8.14,8.92,7.89,23.19-.75,43.61C280,134.08,268.41,147,253.11,159.73c-10.4,8.65-25.27,15-39,17.07a41.47,41.47,0,0,1,.78,4.72,25.22,25.22,0,0,1-1.24,11.67c-1.82,4.65-5.73,8.84-11.3,12.13C195.05,209.65,186.06,211.91,176.27,211.91ZM157,208.58a81,81,0,0,0,16.83,2.53c10.6.4,20.33-1.83,28.16-6.44,3.78-2.23,8.76-6.08,11-11.75a24.41,24.41,0,0,0,1.19-11.32,38.85,38.85,0,0,0-.77-4.69,60.92,60.92,0,0,1-8.58.64,61.38,61.38,0,0,1-2.34,8.11c-.22.66-.46,1.31-.7,2a18.64,18.64,0,0,1-3.44,7.83,29.61,29.61,0,0,1-10.17,8.27A48.64,48.64,0,0,1,157,208.58Zm-26.89-28.64a36.52,36.52,0,0,0,2.5,11.09c3.28,7.52,10.89,13.36,20.87,16a47.91,47.91,0,0,0,30.65-2.21l-1.07.29c-5.39,1.4-11.06,1.53-16.38,1.47-7.43-.08-15.25-.6-22.08-3.82-2.89-1.36-6.58-3.8-7.77-7.71-.77-2.55-.34-5.27.12-7.62q.48-2.42,1.08-4.74c-1.25-7.21-.08-15.37,3.49-23.48a17.22,17.22,0,0,0-1.43,1,21.56,21.56,0,0,0-5.22,6.3A36,36,0,0,0,130.14,179.94Zm-.28,3.76a26.82,26.82,0,0,0,1.95,10.63,16.63,16.63,0,0,0,2.09,3.77c2.76,3.6,7.3,5.43,11.35,6.87l2.22.77c-7.31-3.17-12.82-8.23-15.52-14.41A30.94,30.94,0,0,1,129.86,183.7Zm9-1a28,28,0,0,0,2.89,8.38c4.63,8.53,14.3,14.26,24.63,14.59,9.58.3,19.62-4,26.83-11.45a28.19,28.19,0,0,0,3.86-4.89q.45-.75.84-1.53a17.31,17.31,0,0,1-13.4,7.72,15.8,15.8,0,0,1-2.38-.1,38.18,38.18,0,0,1-19.29,2.44c-9.91-1.14-17.41-5.85-20.09-12.59-1.61-4.06-1.34-8.49-.63-12.2A69.8,69.8,0,0,0,138.83,182.72Zm62.1-.86a32.08,32.08,0,0,1-3.25,7.88,28.81,28.81,0,0,1-4,5,38.73,38.73,0,0,1-19.34,10.92,46.41,46.41,0,0,0,8.52-1.29c4-1,9.7-3.32,13.6-8.2a31.07,31.07,0,0,0,4.58-8.76,14.33,14.33,0,0,0,.08-4.38C201.1,182.65,201,182.26,200.93,181.86Zm-62.52,2.53q-.37,1.58-.69,3.18c-.45,2.26-.87,4.88-.14,7.26,1.11,3.65,4.62,6,7.37,7.25a42.41,42.41,0,0,0,15.13,3.51,29.53,29.53,0,0,1-19-14.14A28.39,28.39,0,0,1,138.41,184.39Zm5.27-14.8,0,.09c-1.1,4.06-2.32,10-.23,15.33,2.57,6.48,9.85,11,19.47,12.13a38,38,0,0,0,17.78-1.93,17.17,17.17,0,0,1-3.55-1.17,15,15,0,0,1-3.31-.92,13.77,13.77,0,0,1-7.16-7.05,5.72,5.72,0,0,1-1.44.4,4.88,4.88,0,0,1-1,0,18.19,18.19,0,0,1-6.34.55c-5.69-.58-11.91-5.21-12-11.7-.07-3.45,1.61-7.11,5-10.88a39.12,39.12,0,0,1,14.12-10,65,65,0,0,0-11.4.89A55.57,55.57,0,0,0,143.68,169.59Zm39.85,25.2c.31,0,.61,0,.92,0a16.47,16.47,0,0,0,14.59-11c.52-1.59.92-3.86-.09-5.71v0a25.09,25.09,0,0,1-8.11,12.24,18.54,18.54,0,0,1-2.79,1.82,29.25,29.25,0,0,1-3.83,2.38Zm-3.73-.56a14.9,14.9,0,0,0,2.19.44c.64-.27,1.26-.57,1.87-.88l.39-.21A17.48,17.48,0,0,1,179.8,194.23Zm-2.48-.92a16.89,16.89,0,0,0,10.32-1.88,24.61,24.61,0,0,0,9.44-13.71q.13-.54.24-1.11a19.8,19.8,0,0,1-3.14-1.53,21.25,21.25,0,0,0-5.4.12l-.28,0c-2.82.3-5.9.56-9.09.61a28.34,28.34,0,0,1-5,5.18,30.22,30.22,0,0,1-5.47,3.64c0,.07.06.15.1.23A16.28,16.28,0,0,0,177.32,193.31Zm-10-7.58a13,13,0,0,0,6.79,6.69l.44.18a16.75,16.75,0,0,1-6.18-7.43l-.06-.15A7.23,7.23,0,0,1,167.31,185.73Zm-.42-31.18A38.14,38.14,0,0,0,151.38,165c-3.25,3.62-4.86,7.11-4.8,10.37.11,6.07,6,10.42,11.36,11a16.52,16.52,0,0,0,4.53-.19,7.46,7.46,0,0,1-3.51-2.87,14.84,14.84,0,0,1-2-6.8c-.36-4-.25-11.39,4.55-16.16A16.23,16.23,0,0,1,172.94,156h0c2.39,0,5.68.51,7.68,2.9a8.17,8.17,0,0,1,1.22,2,12.1,12.1,0,0,1,1,3.75,20.73,20.73,0,0,1,8.76-1.44,15.53,15.53,0,0,0-3.5-3.7,18,18,0,0,0-5.29-2.31A64.27,64.27,0,0,0,166.89,154.55Zm6.05,2.16A15.51,15.51,0,0,0,162,160.82c-4.58,4.55-4.67,11.7-4.32,15.56a14.06,14.06,0,0,0,1.88,6.46,6.41,6.41,0,0,0,4.53,2.91c.7-.19,1.41-.42,2.12-.69a12.33,12.33,0,0,1-.66-3,6.42,6.42,0,0,1-5.06-3.27,7.48,7.48,0,0,1-.69-2.39,11.51,11.51,0,0,1,12.45-13c.22-.18.46-.34.69-.51,2.09-1.44,4-1.93,5.61-1.44a5.13,5.13,0,0,1,3.27,3.52l.25-.09a11.47,11.47,0,0,0-.9-3.71,7.55,7.55,0,0,0-1.11-1.85c-1.92-2.29-5.28-2.64-7.12-2.64ZM198,176.85c-.07.36-.15.71-.23,1.05a23.06,23.06,0,0,1-3.06,7,27.5,27.5,0,0,0,3.65-7.72,4.17,4.17,0,0,0-.36-.37Zm-31.7,5.31a11.41,11.41,0,0,0,.59,2.62c.35-.14.69-.3,1-.46l.06,0a13.46,13.46,0,0,1-.53-2.1A11,11,0,0,1,166.34,182.16Zm35-1.72a16,16,0,0,1,.57,2.51,14.74,14.74,0,0,1,.14,1.76,59.31,59.31,0,0,0,2-7.16c-.68,0-1.36,0-2-.07-.09.4-.19.8-.29,1.19C201.63,179.25,201.48,179.84,201.33,180.44Zm-33.09,1.67a13.5,13.5,0,0,0,.37,1.56,12.72,12.72,0,0,0,1.38-1.88A11.47,11.47,0,0,1,168.24,182.11Zm2.8-.65a17.4,17.4,0,0,1-1.17,1.85,31.13,31.13,0,0,0,4.08-2.86c.81-.66,1.55-1.34,2.24-2a17.14,17.14,0,0,1-5,3Zm-4.76-.07a10.42,10.42,0,0,0,1.12,0v-.06a12.07,12.07,0,0,1,1.36-6.42l-.41-.13a11.53,11.53,0,0,0-1.77,3.8A10.07,10.07,0,0,0,166.28,181.39Zm33.95-1.87a7.68,7.68,0,0,1,.06,1.85c.09-.3.18-.61.26-.92C200.45,180.14,200.34,179.83,200.23,179.52Zm-30.74-4.42a11.37,11.37,0,0,0-1.35,6.18v.08a10.83,10.83,0,0,0,2.39-.51l.09-.17a37.29,37.29,0,0,0,2.2-5.11c-1-.1-2-.23-3-.4Zm1.81-11a10.75,10.75,0,0,0-10.73,12.19,6.83,6.83,0,0,0,.62,2.15,5.67,5.67,0,0,0,4.34,2.83,10.74,10.74,0,0,1,.31-2.88,12.41,12.41,0,0,1,1.81-3.94,2.83,2.83,0,0,1-1.06-1c-.58-1-.42-2.34.46-4a19.42,19.42,0,0,1,4.35-5.36Zm-28.65-5.55c-.11.25-.22.5-.34.75a41.49,41.49,0,0,0-3.75,21.56A69.73,69.73,0,0,1,143,169.33a71.67,71.67,0,0,1,4.85-12.7A26.51,26.51,0,0,0,142.65,158.58Zm30.93,17.06a35.45,35.45,0,0,1-2,4.8,16.7,16.7,0,0,0,6.13-4.6C176.35,175.82,175,175.76,173.58,175.64Zm26.59,1.69q.38.88.72,1.8c.05-.21.1-.43.16-.64s.17-.7.25-1.06l-.62-.05ZM163.8,135.9q-4.43.84-9.19,2.08a51.44,51.44,0,0,0-14.2,5.66c-3.31,2.07-7.71,5.69-9.89,11.22s-1.61,11.92-1,18l.18,1.87c.06.65.11,1.29.17,1.94,0,.15,0,.3,0,.45a37.52,37.52,0,0,1,4.37-11,22.61,22.61,0,0,1,5.41-6.51,16.88,16.88,0,0,1,2.42-1.56c3.31-7,7.61-11.78,12.8-14.14q.75-.33,1.56-.63c.83-1,1.69-2,2.58-3A30.25,30.25,0,0,1,163.8,135.9Zm38.9,21.64a38.48,38.48,0,0,1,2.56,17.34c-.08.64-.17,1.29-.28,1.92a61.11,61.11,0,0,0,8.27-.62A40.17,40.17,0,0,0,202.7,157.54Zm-.47,19.2c.65,0,1.32,0,2,.06.12-.66.22-1.33.29-2,.72-6.52-.86-12.86-3.06-18.45h0l-.77-.68A39.54,39.54,0,0,0,189.73,149a23.77,23.77,0,0,1,5.26,6.87c.23.48.46,1,.67,1.48A19.16,19.16,0,0,1,202.85,172,24.53,24.53,0,0,1,202.23,176.74Zm-2.4-.22c.3,0,.6.09.91.12l.73.05a23.6,23.6,0,0,0,.63-4.73,18.18,18.18,0,0,0-5.86-13.09,39,39,0,0,1,1.29,4.74c.19.87.34,1.72.48,2.54a7.45,7.45,0,0,1,1.8,3,12,12,0,0,1-.08,6c-.06.26-.12.53-.19.8C199.64,176.09,199.73,176.31,199.83,176.52Zm-1.4-.32.24.06a3,3,0,0,0,.08-.32c-.14-.31-.28-.63-.43-.95,0,.34-.08.67-.13,1Zm-4-1.84h0a8.46,8.46,0,0,1,3,1.13c.08-.6.14-1.21.18-1.84a79.5,79.5,0,0,0-5.13-9l-.39-.6-.26,0a19.89,19.89,0,0,0-9,1.42,14.7,14.7,0,0,1-.12,2.47c3.09.73,5.77,2.56,8.38,4.33C192.24,173,193.33,173.71,194.43,174.36Zm-20.61.55c1.51.12,3,.18,4.48.18a16.15,16.15,0,0,0,2.57-5,10.9,10.9,0,0,0,.4-1.7,12.34,12.34,0,0,0-6.16,1.06A39,39,0,0,1,173.82,174.91Zm8.82-6.28a16.24,16.24,0,0,1-1.1,3.54,19,19,0,0,1-1.6,2.91c3-.07,5.84-.32,8.48-.6l.28,0a28.84,28.84,0,0,1,4.06-.24c-.69-.45-1.37-.91-2-1.37C188.19,171.12,185.58,169.34,182.64,168.63Zm-12.76,5.78.08,0c1,.17,2.06.31,3.1.41a37.34,37.34,0,0,0,1.22-5l-.63.33q-.61.5-1.2,1.05A15.12,15.12,0,0,0,169.88,174.41Zm28.56-.9c.2.41.4.83.59,1.24a10.81,10.81,0,0,0,.06-5.4,6.3,6.3,0,0,0-.89-1.8A32.15,32.15,0,0,1,198.44,173.51Zm-29.63.66.3.08a14.55,14.55,0,0,1,.95-1.46A14.69,14.69,0,0,0,168.81,174.17Zm3.69-10a18.59,18.59,0,0,0-4.79,5.65c-.75,1.37-.91,2.46-.47,3.23a2.06,2.06,0,0,0,.86.79,16.59,16.59,0,0,1,5.09-4.31l.05,0c.4-.32.81-.63,1.23-.91.1-.73.18-1.46.23-2.19a2.37,2.37,0,0,0-.14-1.32,2.19,2.19,0,0,0-1.7-.87Zm20.71.06a85.61,85.61,0,0,1,4.53,7.83,35.81,35.81,0,0,0-.44-5.58A9.44,9.44,0,0,0,193.21,164.26Zm-19.87-.68a2.57,2.57,0,0,1,1.88,1.19,3.09,3.09,0,0,1,.23,1.72c0,.54-.09,1.07-.16,1.6a33.58,33.58,0,0,1,5.86-2.83,4.43,4.43,0,0,0-2.78-3.07c-1.41-.41-3.08,0-5,1.35Zm8,2.42a37,37,0,0,0-4.47,2.05,12,12,0,0,1,4.52-.4A6.91,6.91,0,0,0,181.31,166Zm.72-.27a8.46,8.46,0,0,1,.1.88c0-.31,0-.62,0-.92Zm-33.24-9.35a70.17,70.17,0,0,0-4,9.47,55.54,55.54,0,0,1,7.47-10.24q-1.28.24-2.55.54C149.43,156.22,149.11,156.29,148.79,156.38Zm43.81,7a10.69,10.69,0,0,1,4.51,2c-.09-.52-.2-1.06-.31-1.59a35.76,35.76,0,0,0-1.76-6c-.17-.14-.34-.28-.52-.41a26.54,26.54,0,0,0-16.08-4.93,34.1,34.1,0,0,0-9.58,1.43A65.14,65.14,0,0,1,183,156.48a18.63,18.63,0,0,1,5.51,2.42A17.13,17.13,0,0,1,192.6,163.35Zm-37.1-18.9-.31.13c-4.81,2.19-8.84,6.52-12,12.91a29.74,29.74,0,0,1,5.1-1.76A70.14,70.14,0,0,1,155.5,144.45Zm23,7.28a27.62,27.62,0,0,1,15.88,4.67l-.09-.18a23.59,23.59,0,0,0-6.66-8A39.36,39.36,0,0,0,173,146.13a27.71,27.71,0,0,0-8.54,1.62,29.25,29.25,0,0,0-10,6.74,66.34,66.34,0,0,1,12.35-.7,35.48,35.48,0,0,1,11.65-2.06Zm-21.65-7.82a70.69,70.69,0,0,0-7.64,11.58l.33-.07c1.2-.28,2.4-.52,3.6-.73a30.67,30.67,0,0,1,11.05-7.64,28.55,28.55,0,0,1,8.77-1.67,40.23,40.23,0,0,1,12.69,1.46,27.37,27.37,0,0,0-5.16-2.59,36.54,36.54,0,0,0-18.5-1.56A29.25,29.25,0,0,0,156.88,143.91ZM188,147.57a40.4,40.4,0,0,1,12.79,7.22c-.89-2.1-1.85-4.08-2.79-5.9-2.54-5-5.57-9.95-10.45-12.57a21.41,21.41,0,0,0-6.83-2.13h-.05a88.71,88.71,0,0,0-15,1.36,26.34,26.34,0,0,0-6.16,5.24c-.61.67-1.21,1.36-1.8,2.05a32.71,32.71,0,0,1,4.14-.89,37.35,37.35,0,0,1,18.88,1.6A27.85,27.85,0,0,1,188,147.57Zm-3.37-13.26a17.76,17.76,0,0,1,3.27,1.35c5.06,2.72,8.17,7.8,10.77,12.89.92,1.8,1.87,3.75,2.75,5.82a20.74,20.74,0,0,0-5.1-13.92A17.66,17.66,0,0,0,184.65,134.31ZM174,133.62a19,19,0,0,0-5.54.74c2.29-.32,4.5-.56,6.66-.71C174.75,133.63,174.38,133.62,174,133.62Z"
        />
      </g>
      <defs />
    </svg>
  );
};
export default Illus2;
